import * as React from "react";

import {Button, Checkbox, Form, Icon, Input, Modal, Select} from "antd";
import {addingFormComponents, IFieldValue, IVariablesFormFields} from "./VariablesForm";

const {Option} = Select;
const {TextArea} = Input;


interface IVariablesFormProps {
    visible: boolean;
    formKey: string;
    groupKey: string;
}

interface IOption {
    value: string;
    label: string
}

export interface IVariablesFormDispatchProps {
    onAddingNewVariablesField: (name: string, field: IVariablesFormFields) => void
    onCancel?: () => void
}


type IVariablesAddProps = IVariablesFormProps & IVariablesFormDispatchProps

interface IVariableField {
    name: string,
    type: string,
    options?: Array<IOption>;
    optionsString?: string;
}

interface IState {
    newVariables: IVariableField
}

const defaultOptionString = `[{
    "value": "value1",
    "label": "label 1"
},
{
    "value": "value2",
    "label": "label 2"
}]`;

class VariablesFormAdd extends React.Component<IVariablesAddProps, IState> {
    constructor(props: IVariablesAddProps) {
        super(props);
        this.state = {
            newVariables: {
                name: "",
                type: "Input",
                options: [],
                optionsString: defaultOptionString,
            }
        }
    }

    onChangeNewVariables = (fields: Partial<IVariableField>) => {
        this.setState({
            newVariables: {
                ...this.state.newVariables,
                ...fields
            }
        })
    };

    addVariableForGroup = () => {
        if (this.props.onAddingNewVariablesField) {
            let formFields: IVariablesFormFields = {};
            let field: IFieldValue;
            let variableField = this.state.newVariables;

            let value: string | boolean = "";
            if (variableField.type === "Checkbox") {
                value = true
            }
            if (variableField.type === "Select") {
                field = {
                    name: variableField.name,
                    type: variableField.type,
                    options: stringToOptions(variableField.optionsString),
                    value: value
                }
            } else {
                field = {
                    name: variableField.name,
                    type: variableField.type,
                    value: value
                }
            }
            if (variableField.type === "Group") {
                formFields = {
                    [variableField.name]: {}
                }
            } else if (variableField.type === "TextStyle") {
                formFields = {
                    [variableField.name]: {
                        Color: {
                            type: "ColorInput",
                            value: "#000000"
                        },
                        TextShadow: {
                            type: "Input",
                            value: "2px 2px 8px orange"
                        },
                        Font: {
                            type: "Input",
                            value: "italic small-caps bold 20px Georgia, Garamond, serif"
                        },
                        FontFamily: {
                            type: "Input",
                            value: "Georgia, Garamond",
                        },
                        FontSize: {
                            type: "Input",
                            value: "12px"
                        },
                        FontStyle: {
                            type: "Select",
                            options: [
                                {
                                    value: "normal",
                                    label: "normal"
                                },
                                {
                                    value: "italic",
                                    label: "italic"
                                },
                                {
                                    value: "oblique",
                                    label: "oblique"
                                },
                            ],
                            value: "italic"
                        }
                    }
                }
            } else {
                formFields = {
                    [variableField.name]: field
                }

            }
            this.props.onAddingNewVariablesField(variableField.name, formFields)
        }
    };

    onCancel = () => {
        if (this.props.onCancel) {
            this.props.onCancel()
        }
    };

    render() {
        // console.log("VariablesFormAdd render........")
        const formKey = this.props.formKey;
        const key = this.props.groupKey;
        return (
            <Modal
                title={`Add variables to ${formKey}`}
                visible={this.props.visible}
                onCancel={() => this.onCancel()}
                footer={[
                    <Button
                        key="back"
                        onClick={() => this.onCancel()}
                    >
                        Done
                    </Button>
                ]}
            >
                <Form.Item label={"Variable Name"}>
                    <Input
                        value={this.state.newVariables.name}
                        onChange={(e) => this.onChangeNewVariables({name: e.target.value})}
                        placeholder="Define new Variable"
                        style={{width: 220}}
                    />
                </Form.Item>
                <Form.Item label={"Variable Type"}>
                    <Select
                        value={this.state.newVariables.type}
                        style={{width: 220}}
                        defaultValue="Input"
                        onSelect={(value: string) => this.onChangeNewVariables({type: value})}
                    >
                        {
                            Object.keys(addingFormComponents).map((component: string) => {
                                return (<Option key={component}>{component}</Option>)
                            })
                        }
                    </Select>
                </Form.Item>
                {
                    this.state.newVariables.type === "Select" &&
                    <Form.Item label={"Options JSON"}>
                        <TextArea
                            style={{width: 220}}
                            rows={4}
                            value={this.state.newVariables.optionsString}
                            onChange={(e) => this.onChangeNewVariables({optionsString: e.target.value})}
                        />
                    </Form.Item>
                }
                < Form.Item>
                    < Button
                        type="primary"
                        onClick={() => this.addVariableForGroup()}
                    >
                        <Icon type="plus"/> Add
                    </Button>
                </Form.Item>
            </Modal>
        )
    }
}

const stringToOptions = (str: string | undefined): Array<IOption> => {
    if (!str) {
        return []
    }
    try {
        return JSON.parse(str)
    } catch (e) {
        return []
    }
};



export default VariablesFormAdd;

